import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return ($setup.routes.length > 0)
    ? (_openBlock(), _createBlock(_component_el_menu, {
        key: 0,
        "default-active": $setup.activeIndex,
        class: "el-menu-style",
        mode: "horizontal",
        onSelect: _ctx.handleSelect,
        router: true
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.routes, (route) => {
            return (_openBlock(), _createBlock(_component_el_menu_item, {
              key: route,
              route: route,
              "base-path": route.path,
              index: route.path
            }, {
              default: _withCtx(() => [
                (route.meta && route.meta.icon)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: ['fas', route.meta.icon]
                    }, null, 8 /* PROPS */, ["icon"]))
                  : _createCommentVNode("v-if", true),
                _createTextVNode(" " + _toDisplayString(route.name), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["route", "base-path", "index"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["default-active", "onSelect"]))
    : _createCommentVNode("v-if", true)
}